import Cookies from "js-cookie";
import { cookieDomain, cookieSameSite, cookieSecure, defaultLanguage } from "./constants";

export const LANGUAGE_STORAGE_KEY = "idexpress.language";
export const LANGUAGE_COOKIE_KEY = "idexpress_language";

const cookieOptions = {
  expires: 365,
  sameSite: cookieSameSite,
  secure: cookieSecure,
  domain: cookieDomain,
};

export const normalizeLanguageCode = (language?: string | null) => {
  const normalized = language?.toLowerCase().split("-")[0].trim();
  return normalized && /^[a-z]{2}$/.test(normalized) ? normalized : "";
};

export const getBrowserLanguagePreference = () => {
  if (typeof navigator === "undefined") return defaultLanguage;
  return normalizeLanguageCode(navigator.language) || defaultLanguage;
};

export const getStoredLanguagePreference = () => {
  if (typeof window === "undefined") return "";

  const storedLanguage = normalizeLanguageCode(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  if (storedLanguage) return storedLanguage;

  return normalizeLanguageCode(Cookies.get(LANGUAGE_COOKIE_KEY));
};

export const getInitialLanguagePreference = () =>
  getStoredLanguagePreference() || getBrowserLanguagePreference();

export const persistLanguagePreference = (language: string) => {
  const normalized = normalizeLanguageCode(language);
  if (!normalized || typeof window === "undefined") return "";

  localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  localStorage.setItem("i18nextLng", normalized);
  Cookies.set(LANGUAGE_COOKIE_KEY, normalized, cookieOptions);
  Cookies.set("i18next", normalized, cookieOptions);

  return normalized;
};
